import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button,Dialog, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import styles from "../../../styles.module.css";
import { getDeliveryChallanList, editDeleteDeliveryChallan } from "../../../actions/actions";
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip, Grid  } from "@mui/material";
import axiosClient from "../../../configs/axios";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  dateConversion
} from "../../reusableComponent/Reusables";
import deliveryChallanService from "../../../services/deliveryChallan.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import emptycolectionlistSerives from "../../../services/emptycolectionlist.Serives";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import drivermasterSerivice from "../../../services/masters/driverMaster.Service";
import CustomPagination from "../../reusableComponent/CustomPagination";
import inwardService from "../../../services/inward.Service";

const EmptyCollectionList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const isAdminOrManagement = userInfo?.user_role === "admin" || userInfo?.user_role === "management";

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector((state) => state.delivery_challan.total_count || 0);
  const defaultRowsPerPage = useSelector((state) => state.delivery_challan.rows_per_page || 15);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("Cylinder Details");
  const respMsgState = useSelector((state) => state.delivery_challan.message);
  const [openDialog, setOpenDialog] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
const [selectedDepot, setSelectedDepot] = useState(isAdminOrManagement ? '' : (userInfo?.depot_id || ''));

  const fields = [
    "entry_no",
    "entry_date",
    "customer_name",
    "empty_cylinders",
    "full_cylinders",
    "vehicle_no",
    "driver_name",
    "receiving_depot",
  ];
  const labels = [
    "ECR No",
    "Date",
    "Customer Name",
    "Empty Cylinders",
    "Full Cylinders",
    "Vehicle No",
    "Driver Name",
    "Receiving Depot",
  ];
  const [total_count, setTotalCount] = useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  const [depotmap, setDepot] = useState({});
  const [customermap, setCustomer] = useState({});
  const [vehiclemap, setVehicle] = useState({});
  const [cylindermap, setCylinder] = useState({});
  const [drivermap, setDriver] = useState({});
  const [inwardCheckedMap, setInwardCheckedMap] = useState({});



  useEffect(() => {
  async function fetchInwardData() {
    try {
      const inwardResponse = await inwardService.getCylinderInwardList({
        page: 0,
        size: 9999,
        searchKey: "",
      });

      const map = {};
      inwardResponse.forEach((inwardRow) => {
        try {
          const details = JSON.parse(inwardRow.table_details || "[]");
          details.forEach((cyl) => {
            const key = cyl.cyl_no || cyl.cyl_id;
            if (key) {
              if (cyl.checked === true) {
                map[key] = true;
              } else if (!(key in map)) {
                map[key] = false;
              }
            }
          });
        } catch (e) {
          console.error("Error parsing inward table_details", e);
        }
      });

      setInwardCheckedMap(map);
    } catch (error) {
      console.error("Error fetching inward data", error);
    }
  }
  fetchInwardData();
}, []);

useEffect(() => {
  async function fetchMasterData() {
    try {
      const [depotData, customerData, vehicleData, cylinderData, driverData] = await Promise.all([
        depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
        customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
        vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
        cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
        drivermasterSerivice.getDriverList({ page: 0, size: 999, searchKey: "" }),
      ]);

      const depotMap = Object.fromEntries(depotData.map((d) => [d.depot_id, d.depot_name]));
      const customerMap = Object.fromEntries(customerData.map((c) => [c.cust_id, c.cust_name]));
      const vehicleMap = Object.fromEntries(vehicleData.map((s) => [s.vehicle_id, s.vehicle_no]));
      const cylinderMap = Object.fromEntries(
        cylinderData.map((s) => [
          s.cyl_id,
          {
            cylinder_no: s.cylinder_no,
            owner: s.owner,
            customer_id: s.customer_id,
          },
        ])
      );
      const driverMap = Object.fromEntries(driverData.map((s) => [s.driver_id, s.driver_name]));

      // Log data for debugging
      console.log("Cylinder Data:", cylinderData);
      console.log("Customer Data:", customerData);
      console.log("Cylinder Map:", cylinderMap);
      console.log("Customer Map:", customerMap);

      setDepot(depotMap);
      setCustomer(customerMap);
      setVehicle(vehicleMap);
      setCylinder(cylinderMap);
      setDriver(driverMap);
    } catch (error) {
      console.error("Data fetching failed", error);
      setSuccessMessage("Error fetching master data");
    }
  }

  fetchMasterData();
}, []);

  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

const handleOpenDialog = (row) => {
  setSelectedRow(row);
  setSelectedCylinderDetails(() => {
    try {
      return JSON.parse(row.table_details || '[]');
    } catch { return []; }
  });
  setOpenDialog(true);
};

const handleCloseDialog = () => {
  setOpenDialog(false);
  setSelectedRow(null);
  setSelectedCylinderDetails([]);
};

const fetchData = async () => {
  try {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey: searchKey,
        depot_id: selectedDepot || undefined, 
    };
    const response = await emptycolectionlistSerives.EmptyCylinderList(params);
    const processedRows = response.map((row) => {
      let emptyCount = 0;
      let fullCount = 0;

      try {
        const details = JSON.parse(row.table_details || "[]");
        details.forEach((item) => {
          const cylType = item.cyl_type || item.type; // Handle both field names
          if (cylType === "Empty") emptyCount++;
          if (cylType === "Full") fullCount++;
        });

        // Removed prioritization logic to show both counts accurately
      } catch (error) {
        console.error("Error parsing table_details:", error);
      }

    return {
  ...row,
  empty_cylinders: emptyCount,
  full_cylinders: fullCount,
  vehicle_no: row.vehicle_no || row.unregistered_vehicle || '',
  driver_name: row.driver_name || row.unregistered_driver || '',
  receiving_depot: depotmap[row.receiving_depot_id] || row.receiving_depot_id,
};
    });
    setRows(processedRows || []);
  } catch (error) {
    setSuccessMessage("Error fetching data");
    console.error("Fetch error:", error);
  }
};

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    try {
      const params = {
        page: controller.page,
        size: searchValue === "" ? controller.rowsPerPage : rows[0]?.totalCount || 0,
        searchKey: searchValue,
      };
      
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
      setSuccessMessage("Error searching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller, vehiclemap, depotmap, drivermap,selectedDepot]);

  const deleteRecord = async (id) => {
    try {
      await fetch(`/api/empty-collection-list/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ changedUpdatedValue: "delete" }),
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  useEffect(() => {
    if (respMsgState) {
      setSuccessMessage(respMsgState);
    }
  }, [respMsgState]);

  const HandleSort = (field) => {
    const newSortBy = sortBy === field ? null : field;
    setSortBy(newSortBy);

    if (newSortBy) {
      setRows(
        [...rows].sort((a, b) => {
          if (a[newSortBy] < b[newSortBy]) return -1;
          if (a[newSortBy] > b[newSortBy]) return 1;
          return 0;
        })
      );
    } else {
      fetchData();
    }
  };


const isCylinderInwarded = (cyl) => {
  const key = cyl.cyl_no || cyl.cyl_id;
  return inwardCheckedMap[key] === true;
};

const isRowFullyInwarded = (row) => {
  try {
    const details = JSON.parse(row.table_details || "[]");
    if (details.length === 0) return true;
    return details.every((cyl) => isCylinderInwarded(cyl));
  } catch (e) {
    return true;
  }
};

const getOwnerDisplay = (cylinder) => {
  const cylinderInfo = cylindermap[cylinder.cyl_id];
  if (!cylinderInfo) {
    console.warn(`Cylinder ID ${cylinder.cyl_id} not found in cylindermap`);
    return cylinder.owner || 'N/A'; // Fallback to data owner
  }
  const { owner, customer_id } = cylinderInfo;
  const normalizedOwner = owner?.toLowerCase();

  if (normalizedOwner === 'tgpl') {
    return 'TGPL';
  }
  if (normalizedOwner === 'customer') {
    if (customer_id && customermap[customer_id]) {
      return customermap[customer_id];
    } else {
      console.warn(`Customer ID ${customer_id} not found in customermap or missing for cylinder ID ${cylinder.cyl_id}`);
      return 'Unknown Customer';
    }
  }
  console.warn(`Invalid owner for cylinder ID ${cylinder.cyl_id}: owner=${owner}`);
  return cylinder.owner || 'N/A'; // Fallback to data owner
};

const toChallanUrl = (url) => {
  const idx = url.indexOf("uploads/");
  if (idx === -1) return url;
  const origin = (axiosClient.defaults.baseURL || "").replace(/\/api\/?$/, "");
  return `${origin}/${url.slice(idx)}`;
};

const getChallanUrls = (row) => {
  try {
    const v = typeof row.upload_receipt === "string"
      ? JSON.parse(row.upload_receipt || "[]")
      : row.upload_receipt;
    return Array.isArray(v) ? v.filter(Boolean).map(toChallanUrl) : [];
  } catch {
    return [];
  }
};

const isImageUrl = (url) => /\.(jpg|jpeg|png)(\?.*)?$/i.test(url);

const getProductCodesSummary = () => {
  if (!Array.isArray(selectedCylinderDetails) || selectedCylinderDetails.length === 0) return "—";
  const codes = [...new Set(selectedCylinderDetails.map(c => c.prod_code).filter(Boolean))];
  return codes.length > 0 ? codes.join(", ") : "—";
};
 const handleCylinderCountClick = (row, type) => {
  try {
    const details = JSON.parse(row.table_details || "[]");
    // Always filter by the clicked type, no prioritization
    const filteredDetails = details.filter(item => {
      const cylType = item.cyl_type || item.type;
      return cylType === type;
    });
    setSelectedCylinderDetails(filteredDetails);
    setDialogTitle(`${type} Cylinder Details (${filteredDetails.length} Cylinders)`);
    setOpenCylinderDialog(true);
  } catch (error) {
    console.error("Error parsing table_details:", error);
    setSuccessMessage("Error loading cylinder details");
  }
};

  const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
    setDialogTitle("Cylinder Details");
  };

  const totalEmptyCylinders = rows.reduce((sum, row) => sum + row.empty_cylinders, 0);
  const totalFullCylinders = rows.reduce((sum, row) => sum + row.full_cylinders, 0);

  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Empty Challan List" }]} />



        <HeaderSection
          title="EMPTY COLLECTION LIST"
           addNewPath="/transactions/addcollection"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Empty Collection List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />

       <Box sx={{ padding: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <Typography variant="h6">
    Total Cylinders: {totalEmptyCylinders} Empty, {totalFullCylinders} Full
  </Typography>
  {isAdminOrManagement && (
  <select
    value={selectedDepot}
    onChange={(e) => {
      setSelectedDepot(e.target.value);
      setController((prev) => ({ ...prev, page: 0 }));
    }}
    style={{ padding: "8px 12px", borderRadius: "4px", border: "1px solid #ccc", fontSize: "14px", minWidth: "200px" }}
  >
    <option value="">All Depots</option>
    {Object.entries(depotmap).map(([id, name]) => (
      <option key={id} value={id}>{name}</option>
    ))}
  </select>
  )}
</Box>

        <Paper sx={{ width: "100%" }}>
        <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: "15%" }} onClick={() => HandleSort("entry_no")}>
                  ECR No
                  <span className={`${styles.sort_icon}`}>{sortBy === "entry_no" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort("entry_date")}>
                  Date
                  <span className={`${styles.sort_icon}`}>{sortBy === "entry_date" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: "15%" }} onClick={() => HandleSort("customer_name")}>
                  Customer Name
                  <span className={`${styles.sort_icon}`}>{sortBy === "customer_name" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ width: "12%" }} onClick={() => HandleSort("empty_cylinders")}>
                  Empty Cylinders
                  <span className={`${styles.sort_icon}`}>{sortBy === "empty_cylinders" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ width: "10%" }} onClick={() => HandleSort("full_cylinders")}>
                  Full Cylinders
                  <span className={`${styles.sort_icon}`}>{sortBy === "full_cylinders" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: "10%" }} onClick={() => HandleSort("driver_name")}>
                  Driver Name
                  <span className={`${styles.sort_icon}`}>{sortBy === "driver_name" ? "▲" : "▼"}</span>
                </StyledTableCell>
                <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ width: "15%" }} onClick={() => HandleSort("vehicle_no")}>
                  Vehicle No
                  <span className={`${styles.sort_icon}`}>{sortBy === "vehicle_no" ? "▲" : "▼"}</span>
                </StyledTableCell>

                <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ width: "10%" }}>
  Challan
</StyledTableCell>


                
               {isAdminOrManagement && (
                  <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ width: "10%" }} onClick={() => HandleSort("receiving_depot")}>
                    Receiving Depot
                    <span className={`${styles.sort_icon}`}>{sortBy === "receiving_depot" ? "▲" : "▼"}</span>
                  </StyledTableCell>
                )}
                {/* <StyledTableCell align="center" className={`${styles.table_head}`}>
                  Action
                </StyledTableCell> */}
              </StyledTableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: "#fff" }}>
              {Array.isArray(rows) &&
                rows.map((row) => (
              <StyledTableRow
  key={row.entry_id}
  sx={{
    "&:last-child td, &:last-child th": { border: 0 },
    backgroundColor: isRowFullyInwarded(row) ? "inherit" : "#FFF3B0 !important",
    "&:hover": {
      backgroundColor: isRowFullyInwarded(row) ? "#f5f5f5" : "#FDE68A !important",
    },
  }}
>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
  <Typography
    sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2", textDecoration: "underline" }}
    onClick={() => handleOpenDialog(row)}
  >
    {row.entry_no}
  </Typography>
</StyledTableCell>
                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                      {dateConversion(row?.entry_date)}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.customer_name}
                    </StyledTableCell>
                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                      <Tooltip title="Click here to view cylinder  details" arrow>
                        <span
                          onClick={() => handleCylinderCountClick(row, "Empty")}
                          style={{ cursor: 'pointer' }}
                        >
                          {row.empty_cylinders}
                        </span>
                      </Tooltip>
                    </StyledTableCell>


                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                      <Tooltip title="Click here to view cylinder  details" arrow>
                        <span
                          onClick={() => handleCylinderCountClick(row, "Full")}
                          style={{ cursor: 'pointer' }}
                        >
                          {row.full_cylinders}
                        </span>
                      </Tooltip>
                    </StyledTableCell>
<StyledTableCell align="left" className={`${styles.list_table_body}`}>
  {row.driver_name ? row.driver_name : row.unregistered_driver}
</StyledTableCell>

                <StyledTableCell align="center" className={`${styles.list_table_body}`}>
  {row.vehicle_no ? row.vehicle_no : row.unregistered_vehicle}
</StyledTableCell>

<StyledTableCell align="center" className={`${styles.list_table_body}`}>
  {getChallanUrls(row).length === 0 ? (
    "—"
  ) : (
    <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center", alignItems: "center" }}>
      {getChallanUrls(row).map((url, i) =>
        isImageUrl(url) ? (
          <a key={i} href={url} target="_blank" rel="noreferrer">
            <img
              src={url}
              alt="challan"
              style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 4, border: "1px solid #E2E8F0" }}
            />
          </a>
        ) : (
          <a key={i} href={url} target="_blank" rel="noreferrer"
             style={{ fontSize: "12px", color: "#1976d2", textDecoration: "underline" }}>
            📄 PDF
          </a>
        )
      )}
    </Box>
  )}
</StyledTableCell>

                    {isAdminOrManagement && (
                      <StyledTableCell align="left">
                        {row.receiving_depot}
                      </StyledTableCell>
                    )}
                    {/* <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                      linkTo="/transactions/addcollection"
                        showEdit={false}
                        handlePrint={false}
                           handleCancel={false}
                      />
                    </StyledTableCell> */}
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
          <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        

        </Paper>

        <Dialog
          open={openCylinderDialog}
          onClose={handleCloseCylinderDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {dialogTitle}
            <IconButton
              aria-label="close"
              onClick={handleCloseCylinderDialog}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
       <DialogContent>
  <Table size="small">
    <TableHead>
      <StyledTableRow>
        <StyledTableCell>Cylinder No</StyledTableCell>
        <StyledTableCell>Tag No</StyledTableCell>
        <StyledTableCell>Owner</StyledTableCell>
         <StyledTableCell>Prodcut Code</StyledTableCell>
           <StyledTableCell>Status</StyledTableCell>
      </StyledTableRow>
    </TableHead>
    <TableBody>
      {selectedCylinderDetails.length > 0 ? (
        selectedCylinderDetails.map((cylinder, index) => (
          <StyledTableRow key={index} sx={{ alignItems: 'right' }}>
            <StyledTableCell>{cylinder.cyl_no || "N/A"}</StyledTableCell>
            <StyledTableCell>{cylinder.tag_no || "N/A"}</StyledTableCell>
            <StyledTableCell>{getOwnerDisplay(cylinder)}</StyledTableCell>
              <StyledTableCell>{cylinder.prod_code || "N/A"}</StyledTableCell>
               <StyledTableCell>{cylinder.cyl_type || cylinder.type || "N/A"}</StyledTableCell>
          </StyledTableRow>
        ))
      ) : (
        <StyledTableRow>
          <StyledTableCell colSpan={5} align="center">
            No cylinder details available
          </StyledTableCell>
        </StyledTableRow>
      )}
    </TableBody>
  </Table>
</DialogContent>
        </Dialog>

<Dialog
  open={openDialog}
  onClose={handleCloseDialog}
  maxWidth={false}
  sx={{
    "& .MuiDialog-paper": {
      margin: "auto", width: "92vw", maxHeight: "85vh",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      overflow: "hidden", fontFamily: "'Inter', Arial, sans-serif",
    },
  }}
>
  {/* Header */}
  <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
      EMPTY COLLECTION DETAILS
    </Typography>
    <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>

  <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

    {/* Info Card */}
    <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>
      <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
        <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
          📋 Collection Information
        </Typography>
      </Box>
      <Box>
        <Grid container>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>ECR No</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E" }}>{selectedRow?.entry_no || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Date</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{dateConversion(selectedRow?.entry_date) || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Customer Name</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.customer_name || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Receiving Depot</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.receiving_depot || "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Driver Name</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>
              {selectedRow?.driver_name || selectedRow?.unregistered_driver || "—"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Vehicle No</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748"  }}>
              {selectedRow?.vehicle_no || selectedRow?.unregistered_vehicle || "—"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Empty Cylinders</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.empty_cylinders ?? "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Full Cylinders</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{selectedRow?.full_cylinders ?? "—"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ padding: "12px 16px" }}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5 }}>Product Code</Typography>
           <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748" }}>{getProductCodesSummary()}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>

    {/* Cylinder Details Table */}
    <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: "320px" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <StyledTableRow>
              {["Sr No", "Cylinder No", "Tag No", "Owner", "Status", "Remark"].map((header) => (
                <StyledTableCell key={header} align="center"
                  sx={{ backgroundColor: "#1C3A5E !important", color: "#fff !important", fontWeight: 700, fontSize: "12px", padding: "10px 12px", whiteSpace: "nowrap" }}>
                  {header}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {selectedCylinderDetails.length > 0 ? (
              selectedCylinderDetails.map((cyl, index) => (
                <StyledTableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC", "&:hover": { backgroundColor: "#EBF4FF" } }}>
                  {[
                    index + 1,
                    cyl.cyl_no || "—",
                    cyl.tag_no || "—",
                    getOwnerDisplay(cyl),
                    
                    cyl.cyl_type || cyl.type || "—",
                     cyl.note || cyl.level || "—",
                  ].map((val, ci) => (
                    <StyledTableCell key={ci} align="center"
                      sx={{ fontSize: "12px", color: "#2D3748", padding: "8px 12px", borderBottom: "1px solid #EDF2F7", whiteSpace: "nowrap" }}>
                      {val}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={6} align="center" sx={{ py: 5, fontSize: "13px", color: "#A0AEC0" }}>
                  No cylinder details available
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>

  </DialogContent>

  {/* Footer */}
  <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
    <Button onClick={handleCloseDialog}
      sx={{ background: "#E53E3E", color: "#fff", fontSize: "13px", fontWeight: 600, textTransform: "none", padding: "7px 20px", borderRadius: "8px", "&:hover": { background: "#971f16" } }}>
      Close
    </Button>
  </Box>
</Dialog>
        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_no || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default EmptyCollectionList;